import FixedComponent from '@/components/Common/FixedComponent/FixedComponent';
import PageTitle from '@/components/Common/PageTitle/PageTitle';
import StyleComponent from '@/components/Common/StyleComponent/StyleComponent';
import { getSVG } from '@/components/Common/styles/mixins';
import { SunnyFC } from '@/components/Common/SunnyNext';
import { withSunnyPage } from '@/components/Common/SunnyPage';
import { EN_PAGE_NAME } from '@/services/SEOService/metaData';
import { generatePageMeta } from '@/services/SEOService/metaGenerator';
import { GlobalStoreCtx } from '@/stores/GlobalStore';
import { preventAndThrottle, redirectToInstallPage } from '@/utils';
import { getAppDevice } from '@/utils/functions/device';
import React, { useContext } from 'react';

import styles from './install.module.scss';

interface IAppInstallProps {
  platform: 'App' | 'MWeb' | 'Desktop';
  deferredDeepLink: string | undefined;
  imgURL: string;
}

interface IAppInstallQuery {
  [key: string]: string | undefined;
  link?: string;
}

const AppInstall: SunnyFC<IAppInstallProps, IAppInstallQuery> = ({ platform, deferredDeepLink, imgURL }) => {
  const globalStore = useContext(GlobalStoreCtx);
  return (
    <main>
      <FixedComponent type="top">
        <PageTitle left="back">다운로드</PageTitle>
      </FixedComponent>
      <StyleComponent className={styles.layout}>
        <section className={styles.container}>
          <img
            src={imgURL}
            className={styles.img}
            onClick={preventAndThrottle(() => {
              if (!deferredDeepLink) {
                redirectToInstallPage(globalStore.Device);
              } else if (platform !== 'Desktop') {
                location.href = deferredDeepLink;
              } else {
                globalStore.toast.addItem({
                  key: 'app-install-is-not-support',
                  text: 'PC에서는 다운로드 받을 수 없습니다',
                  timeout: 3000,
                });
              }
            })}
          />
        </section>
      </StyleComponent>
    </main>
  );
};
AppInstall.getInitialProps = ({ req, query }) => {
  const appDevice = getAppDevice(req);
  const isApp = !!appDevice;
  const device = req.ua.getDevice();

  const deferredDeepLink = query.deferred;
  const platform = isApp ? 'App' : device.type === 'mobile' || device.type === 'tablet' ? 'MWeb' : 'Desktop';

  return {
    deferredDeepLink,
    platform,
    imgURL:
      req.session.getRemoteConfig().pages?.appInstall?.imgURL ??
      getSVG('/static/images/nol/app-install-default.png'),
    headProps: generatePageMeta({
      pageName: EN_PAGE_NAME.PAGE__LANDING__APP_INSTALL,
      pageUrl: req.requestedUrl,
    }),
  };
};

export default withSunnyPage()(AppInstall);
